const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  selectGroup: {
    height: '14px',
    width: '50px'
  }
}

export default styles
